import type { FooterNavLink } from "@ui/eva-components/Footer/types/FooterNavLink.type";
import dayjs from "dayjs";

import { FooterNavLinks } from "../FooterNavLinks";

import styles from "./Copyright.module.scss";

export type CopyrightProps = {
  copyright: string;
  links?: FooterNavLink[];
  enableCookieSettings: boolean;
  isCurrentYearAppended?: boolean;
  cookieSettingsAriaLabel?: string;
  withdrawalModalTriggerUrl?: string;
  onOpenWithdrawalModal?: () => void;
};

export const Copyright = ({
  copyright,
  links = [],
  enableCookieSettings,
  isCurrentYearAppended,
  cookieSettingsAriaLabel,
  withdrawalModalTriggerUrl,
  onOpenWithdrawalModal,
}: CopyrightProps) => (
  <div className={styles.copyrightContainer}>
    <span className={styles.copyrightText}>{`${copyright}${isCurrentYearAppended ? ` ${dayjs().year()}` : ""}`}</span>
    <FooterNavLinks
      className={styles.copyrightLinks}
      itemClassname={styles.link}
      links={links}
      enableCookieSettings={enableCookieSettings}
      cookieSettingsAriaLabel={cookieSettingsAriaLabel}
      withdrawalModalTriggerUrl={withdrawalModalTriggerUrl}
      onOpenWithdrawalModal={onOpenWithdrawalModal}
    />
  </div>
);
